/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * GRAPHS
 */
const Index = gql`
  query MyQuery {
    SellerFormReadAll {
      id
      message
      status
      thumbnailStoredAt
      plotSummary
      contentType
      contentTitle
      createdAt
      ageRating
      genre
      duration
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
